import { type LoadableEntry } from "~/app/store/loadableTypes";
import { type SrpProductData } from "~/utils/models";
import { useLayoutEffect, useState } from "react";
import { fetchRecentlyViewedProducts as apiFetch } from "~/features/RecentlyViewedProducts/api/fetchRecentlyViewedProducts";
import { addBaseProductDataAction } from "~/domains/product/redux/actions";
import { useDispatch } from "react-redux";

let fetched = false;
let promise: Promise<SrpProductData[]> = Promise.resolve([]);

const fetchRecentlyViewedProducts = async (showLatestProduct: boolean) => {
  if (!fetched) {
    fetched = true;
    promise = apiFetch(true);
  }
  const data = await promise;
  return showLatestProduct ? data : data.slice(1);
};

export const useFetchDataRecently = (showLatestProduct: boolean): LoadableEntry<SrpProductData[]> => {
  const [data, setData] = useState<LoadableEntry<SrpProductData[]>>({ state: "loading", data: [] });
  const dispatch = useDispatch();
  useLayoutEffect(() => {
    fetchRecentlyViewedProducts(showLatestProduct)
      .then((data) => {
        if (data.length > 0) {
          dispatch(addBaseProductDataAction(data));
        }
        setData({ state: "loaded", data });
      })
      .catch(() => setData({ state: "error", data: [] }));
  }, []);

  return data;
};
